import React from 'react';
import HomeSixMain from './HomeSixMain';
import FooterTwo from '../../components/Footer/FooterTwo';
import HeaderSix from '../../components/Header/HeaderSix';
import SubscribeModal from '../../components/Modal';
import ProductModal from '../../components/Modal/ProductModal';

import Logo from '../../assets/img/logo/logo-white-2.png';

const HomeSixOnePage = () => {
  return (
    <>
      <SubscribeModal />

      <ProductModal />

      <HeaderSix isOnePage />

      <HomeSixMain />

      <FooterTwo
        footerClass="it-footer-area it-footer-style-2 it-footer-style-6 black-bg p-relative fix z-index p-relative"
        copyrightClass="it-copyright-area it-copyright-height it-copyright-style-2 it-copyright-style-5"
        footerLogo={Logo}
      />
    </>
  );
};

export default HomeSixOnePage;
